











































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { NodeVo } from '../../../../store/nexus';
export interface NodeDetailsVo {
    x: number;
    y: number;
    lock: boolean;
    size: number;
    title: string[];
    activation: boolean;
    isType: string;
    userInfoVoList: {
        propertyName: string;
        propertyValue: string;
        display: boolean;
        seqNum: number;
    }[];
}
@Component({
    components: {}
})
export default class NodeDetails extends Vue {
    @Prop()
    dataSource!: NodeDetailsVo;
    infoVoList: any[] = [];
    styleObject: {
        transform?: string;
        opacity?: number;
        visibility?: string;
    } = {};
    enterId?: number;
    leaveId?: number;
    box?: HTMLElement;
    tips?: HTMLElement;
    isType: boolean = true;
    @Watch('dataSource.activation')
    onUpData(activation: boolean) {
        clearTimeout(this.leaveId);
        clearTimeout(this.enterId);
        this.infoVoList = this.dataSource.userInfoVoList;
        this.isType = this.dataSource.isType === 'link';
        this.cluster();
        if (activation) {
            this.enterId = setTimeout(() => {
                this.styleObject = { opacity: 1, visibility: 'visible' };
                this.isRect();
            }, 100);
        } else {
            this.leaveId = setTimeout(() => {
                this.styleObject = {
                    visibility: 'hidden',
                    opacity: 0
                };
            }, 100);
        }
    }
    cluster() {
        // 等于节点数据时执行聚合
        if (!this.isType) {
            this.infoVoList.sort((a: any, b: any) => {
                const c = a.propertyType;
                const d = b.propertyType;
                return c - d;
            });
        }
    }
    isRect() {
        if (this.tips && this.box) {
            const tipsRect = this.tips.getBoundingClientRect();
            const boxRect: ClientRect = this.box.getBoundingClientRect();
            let x = Math.max(this.dataSource.x, 0);
            if (x > boxRect.width - tipsRect.width) {
                x = x - tipsRect.width - this.dataSource.size;
            }
            const y = Math.min(
                Math.max(this.dataSource.y, 0),
                boxRect.height - tipsRect.height - 10
            );
            this.styleObject = {
                transform: `translate(${x}px,${y}px)`,
                opacity: 1,
                visibility: 'visible'
            };
        }
    }
    onMouseenter() {
        this.dataSource.activation = true;
    }

    onMouseleave() {
        this.dataSource.activation = false;
    }
    mounted() {
        this.tips = this.$refs.tips as HTMLElement;
        this.box = this.tips.parentNode as HTMLElement;
    }
}
